import { createBrowserHistory } from "history"

export const pathName = window.location.pathname.split("/")

const history = createBrowserHistory({
	basename: `/${pathName[1] ?? "enem-vip"}`
})

export default history
